import { TbCurrencyDollarCanadian } from 'react-icons/tb';

const PackageCard = ({
  plan,
}: {
  plan: { id: number; name: string; price: number; credits: number };
}) => {
  // destructuring the plan object here
  const { name, price, credits } = plan || {};

  // destructing the price here
  const [integerPart, fractionPart] = price.toString().split('.');

  // rendering package card component here
  return (
    <div className='embla__slide min-h-[300px] rounded-tl-xl rounded-br-xl flex flex-col text-legal-white overflow-hidden bg-gradient-to-br from-[#f7e7c7] via-legal-white to-[#f7e7c7] p-5'>
      <div>
        <h3 className='text-3xl italic text-legal-dark-blue font-bold w-fit'>
          {name}
        </h3>

        <ul className='ml-5 mt-5 text-legal-dark-blue font-marcellus list-disc font-semibold text-sm'>
          <li>
            Get {credits} credits for CAD {price}.
          </li>

          <li>Get lifetime access.</li>
        </ul>
      </div>

      <div className='flex items-end justify-center md:justify-end font-marcellus flex-1'>
        <h3 className='flex items-center justify-center gap-1 text-center font-bold text-4xl md:text-5xl text-legal-dark-blue'>
          <TbCurrencyDollarCanadian className='size-10 md:size-14' />
          {integerPart}
        </h3>

        <div>
          <h4 className='font-light text-3xl md:text-4xl text-legal-dark-blue leading-[1]'>
            .{fractionPart ? fractionPart.padEnd(2, '0') : '00'}
          </h4>
          <span className='font-semibold text-xs md:text-sm text-legal-dark-blue'>
            /{credits} Credits
          </span>
        </div>
      </div>
    </div>
  );
};

export default PackageCard;
